// paladin.core
import ChiRhosClient from './chirhos'
import ChiRhosClientV2 from './chirhos/next.js'
import ChiRhosClientV3 from './chirhos/v3.js'
import StateModules from './state/store'
import * as PaladinCoreStateHelpers from './state/helpers'
import CoreUtils from './utils'
const { name, version } = require('../package.json') // TODO: Needs an index.js that exports all utils

// Export utils
let PaladinCoreUtils = CoreUtils

const install = (Vue, options) => {
  if (PaladinCore.installed) {
    return
  }
  PaladinCore.installed = true

  let _timestamp = null
  if (process.env.NODE_ENV === 'development') {
    _timestamp = new Date()
    // eslint-disable-next-line
    console.log(
      `%c${name}` + `%c#${version}: ` + '%cInstalling Module...',
      'color: #2ecc71',
      'color: #3498db',
      ''
    )
  }

  const { store, chirhos /*, onCompleteCallback */ } = options

  if (!store) {
    throw new Error('Please provide a vuex store.')
  }

  if (!chirhos) {
    throw new Error('Please provide provide ChiRhos settings.')
  }

  // Register vuex stores
  for (const module in StateModules) {
    store.registerModule(module, StateModules[module])
  }

  Vue.$store = Vue.$store || store

  // Update ChiRhos config state
  store.dispatch('chirhos/saveConfig', chirhos)

  // var _identity = getSavedState('auth.identity')
  //   ? getSavedState('auth.identity')
  //   : {}

  // var _chirhosConfig = getSavedState('chirhos.config')
  //   ? getSavedState('chirhos.config')
  //   : {}

  // var _accessToken = _identity ? _identity.accessToken || '' : ''
  // var _chirhosApiUrl = _chirhosConfig ? _chirhosConfig.apiUrl || '' : ''

  // let _callback = null
  // if (onCompleteCallback) {
  //   _callback = onCompleteCallback
  // }

  // Get user profile commit to state
  // if ((!store.user || !store.user.profile) && _accessToken && _chirhosApiUrl) {
  //   store.dispatch('user/initialize', _callback).then((response) => {
  //     // console.log(response)
  //   })
  // }

  // not sure about the below yet
  // define global methods (optional)
  // define instance methods (optional)
  // define mixins, directives, filters, etc. (optional)

  if (process.env.NODE_ENV === 'development') {
    let _executionTime = new Date() - _timestamp
    let _msColor = _executionTime < 100 ? '#2ecc71' : '#f1c40f'
    if (_executionTime >= 200) _msColor = '#e74c3c'
    // eslint-disable-next-line
    console.log(
      `%c${name}` +
        `%c#${version}: ` +
        '%cInstalled in ' +
        `%c${_executionTime}ms`,
      'color: #2ecc71',
      'color: #3498db',
      '',
      `color: ${_msColor}`
    )
  }
}

// export ChiRhos
let ChiRhos = ChiRhosClient
let ChiRhosNext = ChiRhosClientV2
let ChiRhosV3 = ChiRhosClientV3

const PaladinCore = {
  install,
  version,
}

// Exports
export {
  PaladinCore,
  PaladinCoreStateHelpers,
  PaladinCoreUtils,
  ChiRhos,
  ChiRhosNext,
  ChiRhosV3,
}

// TODO: Cleanup - Move into helper
// function getSavedState(key) {
//   return JSON.parse(window.localStorage.getItem(key))
// }

// #Automatic Installation
// For people who use your plugin outside of a module system,
// it is often expected that if your plugin is included after
// the Vue script tag, that it will automatically install itself
// without the need to call Vue.use(). You can implement this by
// appending these lines to the end of my-vue-plugin.js:
// if (typeof window !== 'undefined' && window.Vue) {
//   window.Vue.use(PaladinCore)
// }
